export enum TaskStatus {
  PENDING = 'Pending',
  PAUSED = 'Paused',
  WORKING = 'Working',
  COMPLETED = 'Completed',
  STACKED = 'Stacked',
  PRIORITY = 'Priority',
  ALL_ACTIVE = '',
}
